/* eslint-disable react/prop-types */
import React from 'react';
import { ContainerSelect, Select } from './style.js';

const SelectDefault = ({ children, Margin, Width, Text, ...rest }) => {
  return (
    <>
      <ContainerSelect Width={Width} Margin={Margin}>
        <label>{Text}</label>
        <Select {...rest}>{children}</Select>
      </ContainerSelect>
    </>
  );
};

export default SelectDefault;
